import Script from 'next/script'
import React, { FC, useEffect } from 'react'

import { gtm } from '@Globals/Google/DataLayer'

const UserCentricButtonStyles = `
  font-size: 12px;
  letter-spacing: 0.5px;
  padding: 0 14px !important;
  line-height: 1;
  height: 40px;
  border-radius: 24px;
  display: flex;
  align-items: center;`

// CookiePolicyStyles
const UserCentricStyles = `
#uc-tab-list,
*[data-testid] { background: var(--white); }
*[data-testid="uc-overlay"]{ background: var(--black); }
div[data-testid="uc-default-wall"] { outline: unset !important; }
button[data-testid=uc-save-button] { background-color: transparent; color: var(--black); ${UserCentricButtonStyles} }
button[data-testid=uc-save-button]:hover { border-color: var(--brown-300); background-color: var(--neutral-100); }
button[data-testid=uc-deny-all-button] { background-color: transparent; border: 1px solid var(--black); color: var(--black); ${UserCentricButtonStyles} }
button[data-testid=uc-deny-all-button]:hover { border-color: var(--brown-300); background-color: var(--neutral-100); }
button[data-testid=uc-accept-all-button] { background-color: var(--black); color: var(--white); ${UserCentricButtonStyles} }
button[data-testid=uc-accept-all-button]:hover { background-color: var(--neutral-800); color: var(--white); ${UserCentricButtonStyles} }
button[aria-selected="true"] { color: var(--primary); border-bottom-color: var(--primary); }
div[data-testid=uc-container]~div,
div[data-testid=uc-header-wrapper] { background-color: var(--white); }
button[aria-disabled="true"]>svg>g>g>g>path:first-child{ fill: var(--neutral-200); }
button[aria-checked="true"]>svg>g>g>g>path:first-child{ fill: var(--primary); }
button[aria-checked="false"]>svg>g>g>g>path:first-child{ fill: var(--black); }

`
export const UserCentricsScript = ({ storeID }) => (
  <Script
    data-settings-id="yVg5SCH8r"
    id="usercentrics-cmp"
    onError={(e) => {
      console.warn('User Centrics failed: ', e)
    }}
    onLoad={() => {
      if (!['1', '4', '11', '12', '18', '21', '26', '6', '5', '14', '7', '15', '24', '10', '23', '16', '25', '22', '9', '17'].includes(storeID)) {
        window.addEventListener('UC_UI_INITIALIZED', () => {
          const usercentricsRoot: HTMLElement | null = document.getElementById('usercentrics-root')
          if (usercentricsRoot && usercentricsRoot.shadowRoot) {
            const style = document.createElement('style')
            style.innerHTML = `
            ${UserCentricStyles}
            button[data-testid=uc-deny-all-button] { display: none; }
          `
            usercentricsRoot.shadowRoot.append(style)
          }
        })
      } else {
        window.addEventListener('UC_UI_INITIALIZED', () => {
          const usercentricsRoot: HTMLElement | null = document.getElementById('usercentrics-root')
          if (usercentricsRoot && usercentricsRoot.shadowRoot) {
            const style = document.createElement('style')
            style.innerHTML = `
            ${UserCentricStyles}
          `
            usercentricsRoot.shadowRoot.append(style)
          }
        })
      }
    }}
    src="https://app.usercentrics.eu/browser-ui/latest/loader.js"
    strategy="afterInteractive"
    type="module"
  />
)

export const UserCentricsFallback: FC = () => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    const w = window as any
    if (w.gtmConsentOnce) {
      return
    }

    w.gtmConsentOnce = true

    gtm({ ConsentAllServices: true, event: 'consent_status' })
  }, [])

  return null
}
